import { useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';
import { Button, createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { FormFieldRequirementIndicator, TextField } from '@app/components';

import './CreateAccountForm.scss';

const cnBem = createBemBlockBuilder(['createAccountForm']);

const passwordRequirements = [
  {
    title: 'One number',
    id: 'createAccount.oneNumber',
  },
  {
    title: 'Six character minimum',
    id: 'createAccount.sixCharacter',
  },
  {
    title: 'One special character',
    id: 'createAccount.oneSpecialCharacter',
  },
  {
    title: 'Do not include username',
    id: 'createAccount.notUsername',
  },
  {
    title: 'Do not include email address',
    id: 'createAccount.notEmailAddress',
  },
  {
    title: 'Do not include common phrases',
    id: 'createAccount.notCommonPhrases',
  },
];

export const CreateAccountForm = () => {
  const { $t } = useIntl();
  const { handleSubmit, control } = useForm({ mode: 'onTouched' });

  return (
    <form
      data-auto="create-account-form"
      onSubmit={handleSubmit(values => {
        // eslint-disable-next-line no-console
        console.log(values);
      })}
    >
      <h2 className={cnBem('__title')}>
        {$t({
          id: 'createAccount.formTitle',
          defaultMessage: 'Create an account',
        })}
      </h2>
      <div className={cnBem('__rowMessage')}>
        {$t({
          id: 'createAccount.formMessage',
          defaultMessage:
            'Creating an account allows you to save items for later, view your search history and more! To request items you need to register for a reader identification card after you create an account.',
        })}
      </div>
      <div className={cnBem('__row')}>
        <TextField
          label={$t({
            id: 'createAccount.firstName',
            defaultMessage: 'First name',
          })}
          name="firstName"
          control={control}
        />
      </div>
      <div className={cnBem('__row')}>
        <TextField
          label={$t({
            id: 'createAccount.lastName',
            defaultMessage: 'Last name',
          })}
          name="lastName"
          control={control}
        />
      </div>
      <div className={cnBem('__row')}>
        <TextField
          label={$t({
            id: 'createAccount.emailAddress',
            defaultMessage: 'Email address',
          })}
          name="email"
          control={control}
        />
      </div>
      <div className={cnBem('__row')}>
        <TextField
          label={$t({
            id: 'createAccount.createPassword',
            defaultMessage: 'Create password',
          })}
          name="password"
          control={control}
        />
      </div>
      <div className={cnBem('__passwordRules')}>
        {passwordRequirements.map(passwordRequirement => (
          <FormFieldRequirementIndicator
            key={passwordRequirement.id}
            message={$t({
              id: passwordRequirement.id,
              defaultMessage: passwordRequirement.title,
            })}
            isValid={false}
          />
        ))}
      </div>
      <div className={cnBem('__row')}>
        <Button
          className={cnBem('__submitButton')}
          styleType="solid"
          type="submit"
        >
          {$t({
            id: 'createAccount.createAccount',
            defaultMessage: 'Create account',
          })}
        </Button>
      </div>
    </form>
  );
};
